import postscribe from 'postscribe';
import AbstractDriver from './abstract-driver';

/* eslint no-undef: "error" */
class Hubspot extends AbstractDriver
{
    constructor()
    {
        super();

        this.firstLoad = false;
    }

    init(config)
    {
        if (!this.firstLoad) this._loadScript(config);
    }

    async pageView()
    {
        return true;
    }

    async lead()
    {
        return true;
    }

    _exists()
    {
        return true;
    }

    _loadScript()
    {
        postscribe(document.querySelector('head'), `
            <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/4919489.js?businessUnitId=611442"></script>
        `, {
            done: () =>
            {
                this.firstLoad = true;
                this.init();
            },

        });

        return true;
    }
}

export default Hubspot;
